/*
 * treatment (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { treatments } from "./treatment.schema"

/* Select */
export type Treatment = z.infer<typeof selectTreatmentSchema>
export const selectTreatmentSchema = createSelectSchema(treatments)

/* Filters */
export type TreatmentFilters = z.infer<typeof treatmentFiltersSchema>
export const treatmentFiltersSchema = z.object({
	id: z.string().optional(),
	treatmentPlanId: z.string().optional(),
	patientId: z.string().optional(),
	timePeriodId: z.number().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createTreatmentSchema = createInsertSchema(treatments).partial(globalCreateExclude)
export type CreateTreatment = z.infer<typeof createTreatmentSchema>

/* Update */
export const updateTreatmentSchema = createInsertSchema(treatments)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateTreatment = z.infer<typeof updateTreatmentSchema>
